import React from 'react';
import { UniverseModuleType } from 'src/domains/common/universes.type';
import { features } from './dragonbet.features';
import { themeColors } from './dragonbet.config';
import { DragonBetLogotype } from './dragonbet.logotype';
import { DragonBetLogo } from 'src/layouts/LoginPage/logos/DragonBetLogo';
import DragonBetLoginImage from 'src/layouts/LoginPage/loginBgImages/DragonBetLoginImage.jpg';
import { DragonbetBrandIconWrapper, CompliancePopupLogo } from './dragonbet.style';
import { LoginImageWrapper } from 'src/layouts/LoginPage/LoginImage.style';

export const universeModule: UniverseModuleType = {
    themeColors,
    features,
    title: 'DragonBet Backoffice',
    urls: {
        website: 'https://dragonbet.co.uk/',
        backoffice: 'https://backoffice.dragonbet.co.uk/',
    },
    BrandIcon: () => <DragonbetBrandIconWrapper />,
    Logotype: () => <DragonBetLogotype />,
    LogotypeLoginPage: () => <DragonBetLogo />,
    compliancePopupLogo: () => <CompliancePopupLogo />,
    loginImageContainer: () => <LoginImageWrapper imgSrc={DragonBetLoginImage} />,
};
